var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { attrs: { id: "login-div" } }, [
    _c("h1", { staticClass: "page-title mt-2" }, [
      _vm._v("\n    " + _vm._s(_vm.$t("loginTitle")) + "\n  ")
    ]),
    _vm._v(" "),
    _c("h2", { staticClass: "content mt-3" }, [
      _vm._v("\n    " + _vm._s(_vm.$t("loginSubtitle")) + "\n  ")
    ]),
    _vm._v(" "),
    _c(
      "form",
      {
        staticClass: "mt-5",
        on: {
          submit: function($event) {
            $event.stopPropagation()
            $event.preventDefault()
            return _vm.handleSubmit.apply(null, arguments)
          }
        }
      },
      [
        _c(
          "b-alert",
          {
            attrs: { show: _vm.ui.showError, variant: "danger" },
            on: {
              "update:show": function($event) {
                return _vm.$set(_vm.ui, "showError", $event)
              }
            }
          },
          [
            _vm._v("\n      " + _vm._s(_vm.ui.showErrorMessage) + "\n      "),
            _vm.ui.showValidateAccountError
              ? _c(
                  "a",
                  {
                    staticClass: "error-danger-link",
                    attrs: { href: "#" },
                    on: { click: _vm.resendValidateAccountMail }
                  },
                  [
                    _vm._v(
                      "\n        " +
                        _vm._s(_vm.$t("account.not.validated.resent.error")) +
                        "\n      "
                    )
                  ]
                )
              : _vm._e()
          ]
        ),
        _vm._v(" "),
        _c(
          "b-form-group",
          {
            attrs: {
              label: _vm.$t("loginFirstCredential"),
              "label-for": "username-input"
            }
          },
          [
            _c("b-form-input", {
              attrs: { id: "username-input", type: "email", required: "" },
              on: { keydown: _vm.hideError },
              model: {
                value: _vm.form.username.value,
                callback: function($$v) {
                  _vm.$set(_vm.form.username, "value", $$v)
                },
                expression: "form.username.value"
              }
            })
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "b-form-group",
          {
            attrs: {
              label: _vm.$t("loginSecondCredential"),
              "label-for": "password-input"
            }
          },
          [
            _c(
              "b-input-group",
              [
                _c("b-form-input", {
                  ref: "password",
                  staticClass: "form-input-with-right-append-inside",
                  attrs: {
                    id: "password-input",
                    type: _vm.showPassword ? "text" : "password",
                    autocomplete: "off",
                    required: ""
                  },
                  on: { keydown: _vm.hideError },
                  model: {
                    value: _vm.form.password.value,
                    callback: function($$v) {
                      _vm.$set(_vm.form.password, "value", $$v)
                    },
                    expression: "form.password.value"
                  }
                }),
                _vm._v(" "),
                _c("b-input-group-append", [
                  _c(
                    "div",
                    {
                      staticClass: "cursor-pointer custom-eye",
                      on: {
                        click: function($event) {
                          $event.preventDefault()
                          return _vm.togglePassword.apply(null, arguments)
                        }
                      }
                    },
                    [
                      !_vm.showPassword
                        ? _c("i", { staticClass: "ph-custom ph-eye-fill" })
                        : _c("i", {
                            staticClass: "ph-custom ph-eye-slash-fill"
                          })
                    ]
                  )
                ])
              ],
              1
            ),
            _vm._v(" "),
            _c("div", { staticClass: "d-flex justify-content-between mt-1" }, [
              _c(
                "div",
                [
                  _c(
                    "b-form-checkbox",
                    {
                      staticClass: "remember-me",
                      attrs: { id: "remember_me" },
                      model: {
                        value: _vm.form.rememberMe.value,
                        callback: function($$v) {
                          _vm.$set(_vm.form.rememberMe, "value", $$v)
                        },
                        expression: "form.rememberMe.value"
                      }
                    },
                    [
                      _vm._v(
                        "\n            " +
                          _vm._s(_vm.$t("Remember.me")) +
                          "\n          "
                      )
                    ]
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "text-right" },
                [
                  _c(
                    "b-link",
                    {
                      staticClass: "link-main-color",
                      on: { click: _vm.showForgotPasswordView }
                    },
                    [_vm._v(_vm._s(_vm.$t("forgotPasswordText")))]
                  )
                ],
                1
              )
            ])
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass:
              "mt-5 d-flex justify-content-center flex-column align-items-center"
          },
          [
            _c(
              "b-button",
              {
                staticClass: "btn-block",
                attrs: { type: "submit", variant: "primary" }
              },
              [_vm._v(_vm._s(_vm.$t("LogInButtonText")))]
            ),
            _vm._v(" "),
            _c("div", { staticClass: "mt-3 d-flex justify-content-center" }, [
              _c("span", { staticClass: "content" }, [
                _vm._v(
                  "\n            " +
                    _vm._s(_vm.$t("Login.no.account")) +
                    "\n          "
                )
              ]),
              _vm._v(" "),
              _c(
                "a",
                {
                  staticClass: "ml-1 signup-link",
                  on: { click: _vm.showSignUpView }
                },
                [_vm._v(_vm._s(_vm.$t("Login.goToRegister")))]
              )
            ])
          ],
          1
        )
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-2da73bc0", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2da73bc0","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/auth/components/LoginComponent.vue
// module id = uzOg
// module chunks = 0